import { ReactNode } from 'react';
import classNames from 'classnames';

export default function Panel({
  className = 'relative',
  children,
}: {
  className?: string;
  children?: ReactNode;
}) {
  return (
    <div className={classNames(className)}>
      {children}
      {/*<div*/}
      {/*  className={classNames(*/}
      {/*    'absolute',*/}
      {/*    'bottom-[170px]',*/}
      {/*    'left-[12px]',*/}
      {/*    'right-[12px]',*/}
      {/*    'h-[24px]',*/}
      {/*    'bg-linear-to-t',*/}
      {/*    'from-gray-100',*/}
      {/*    'from-10%',*/}
      {/*    'via-gray-100',*/}
      {/*    'via-30%',*/}
      {/*    'to-transparent'*/}
      {/*  )}*/}
      {/*></div>*/}
      {/*<div*/}
      {/*  className={classNames(*/}
      {/*    'absolute',*/}
      {/*    'top-0',*/}
      {/*    'left-[12px]',*/}
      {/*    'right-[12px]',*/}
      {/*    'h-[24px]',*/}
      {/*    'bg-linear-to-b',*/}
      {/*    'from-gray-100',*/}
      {/*    'from-10%',*/}
      {/*    'via-gray-100',*/}
      {/*    'via-30%',*/}
      {/*    'to-transparent'*/}
      {/*  )}*/}
      {/*></div>*/}
    </div>
  );
}
